'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var index = require('../../../../../../../node_modules/@fortawesome/pro-regular-svg-icons/index.cjs');
var index_es = require('../../../../../../../node_modules/@fortawesome/react-fontawesome/index.es.cjs');
var Typography_web = require('../../../atoms/Typography/Typography.web.cjs');
require('@emotion/react');
require('react');
require('../../../../utils/AviaryProvider/AviaryThemeContext.cjs');
require('../../../../../../../_virtual/index2.cjs');
require('aviary-tokens');
require('../../../../../../../_virtual/index.cjs');
var useSanitizeInputErrors = require('../../../../utils/hooks/useSanitizeInputErrors.cjs');
var InternalInputCaption_web_styles = require('./InternalInputCaption.web.styles.cjs');

/**
 * Descriptive text displayed below an input for extra clarification or error state
 *
 * @scope Core
 */ const InternalInputCaption = ({ id, inputCaption, errorCaption, ...rest })=>{
    const { hasError, sanitizedErrorCaption } = useSanitizeInputErrors.useSanitizeInputErrors(errorCaption);
    if (!inputCaption && !hasError) {
        return null;
    }
    const renderContent = ()=>{
        if (hasError) {
            return /*#__PURE__*/ jsxRuntime.jsx("div", {
                css: InternalInputCaption_web_styles.errorArray,
                children: sanitizedErrorCaption.map((error, index)=>/*#__PURE__*/ jsxRuntime.jsx(Typography_web.Typography, {
                        variant: "footnote",
                        isMarginless: true,
                        customCss: InternalInputCaption_web_styles.errorsText,
                        children: error
                    }, index))
            });
        }
        return /*#__PURE__*/ jsxRuntime.jsx(Typography_web.Typography, {
            variant: "footnote",
            isMarginless: true,
            customCss: InternalInputCaption_web_styles.captionText,
            children: inputCaption
        });
    };
    return /*#__PURE__*/ jsxRuntime.jsxs("div", {
        id: hasError ? `${id}-error` : `${id}-description`,
        css: InternalInputCaption_web_styles.container,
        "data-testid": "aviary-input-caption",
        "aria-live": hasError ? "polite" : undefined,
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx(index_es.FontAwesomeIcon, {
                icon: hasError ? index.faCircleExclamation : index.faInfoCircle,
                css: hasError ? InternalInputCaption_web_styles.errorsIcon : InternalInputCaption_web_styles.captionIcon
            }),
            renderContent()
        ]
    });
};

exports.InternalInputCaption = InternalInputCaption;
//# sourceMappingURL=InternalInputCaption.web.cjs.map
